function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as e } from "./index.es33.js";
import { clsx as m } from "./index.es105.js";
import { Typography as h } from "./index.es35.js";
import "./index.es36.js";
import { Header as f } from "./index.es676.js";
import { SortingIndicator as x } from "./index.es677.js";
import t from "./index.es600.js";
import l from "./index.es198.js";

var b = function b(_ref) {
  var _m, _m2;

  var n = _ref.header,
      o = _ref.accessor,
      r = _ref.isUnsortable,
      a = _ref.isInnerSorted,
      i = _ref.isAlreadySorted,
      d = _ref.isSortOrder,
      c = _ref.onClick,
      _ref$withoutRightPadd = _ref.withoutRightPadding,
      p = _ref$withoutRightPadd === void 0 ? !1 : _ref$withoutRightPadd,
      s = _ref.isShortColumn;
  return e.jsx(h.Body2, {
    as: "th",
    className: m("table__thead-cell", t.head, (_m = {}, _defineProperty(_m, t.withSortingIndicator, !r), _defineProperty(_m, t.headUnSortable, r), _defineProperty(_m, t.shortHeadColumn, s), _defineProperty(_m, "withoutRightPadding", p), _m)),
    onClick: function onClick() {
      return c === null || c === void 0 ? void 0 : c(o);
    },
    children: e.jsxs("div", {
      className: m("table__cell-inner", l.cellInner, (_m2 = {}, _defineProperty(_m2, l.cellInnerUnSortable, r), _defineProperty(_m2, l.cellInnerSorted, a), _defineProperty(_m2, l.cellInnerSortOrder, d), _m2)),
      children: [e.jsx(f, {
        title: n
      }), !r && e.jsx(x, {
        isAlreadySorted: i
      })]
    })
  }, o);
};

export { b as Cell };